import React, { createContext, useContext, useState, ReactNode } from 'react';

interface FeedbackContextType {
    projectSectionContentId: string | null;
    setProjectSectionContentId: (id: string | null) => void;
}

const FeedbackContext = createContext<FeedbackContextType | undefined>(undefined);

export const FeedbackProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [projectSectionContentId, setProjectSectionContentId] = useState<string | null>(null);

    return (
        <FeedbackContext.Provider value={{ projectSectionContentId, setProjectSectionContentId }}>
            {children}
        </FeedbackContext.Provider>
    );
};

export const useFeedback = (): FeedbackContextType => {
    const context = useContext(FeedbackContext);
    if (!context) {
        throw new Error('useFeedback must be used within a FeedbackProvider');
    }
    return context;
};
